import React, { FunctionComponent } from 'react';
import { SbBlokData, storyblokEditable } from '@storyblok/react';

import { Accordion, Button } from '@savebetter/components';

import { LinkProps } from './Link';
import { PageSectionBlok, PageSectionProps } from './PageSection';
import { PageSectionHeader } from './PageSectionHeader';
import { RichText } from './RichText';
import { Section } from './Section';

interface FaqItem extends SbBlokData {
  question: string;
  answer: string;
}

interface Blok extends PageSectionBlok {
  title: string;
  questions: FaqItem[];
  link: LinkProps[];
}

interface FaqProps extends PageSectionProps {
  blok: Blok;
}

export const Faq: FunctionComponent<React.PropsWithChildren<FaqProps>> = ({ blok, sectionClassName }) => {
  const { hasBackground, hasBorder, title, link: links = [], questions = [], hasPaddingBottom, hasPaddingTop } = blok;
  const [link] = links;

  return (
    <Section
      width="sm"
      hasBackground={hasBackground}
      hasBorder={hasBorder}
      className={sectionClassName}
      blok={blok}
      hasPaddingBottom={hasPaddingBottom}
      hasPaddingTop={hasPaddingTop}
    >
      <PageSectionHeader className="pb-12 lg:pb-14">{title}</PageSectionHeader>
      {questions.map(blok => {
        const { _uid, question, answer } = blok;
        const content = typeof answer === 'string' ? answer : <RichText content={answer} />;

        return (
          <Accordion
            id={_uid ? _uid : 'accordion_item'}
            header={question}
            content={content}
            className="mb-6"
            key={_uid}
            {...storyblokEditable(blok)}
          />
        );
      })}
      {link && (
        <div className="text-center">
          <Button href={link.url} className="mt-12 lg:mt-14 inline-flex" target={link.target}>
            {link.text}
          </Button>
        </div>
      )}
    </Section>
  );
};
